import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const GarrisonAuditService = {
    getAllByNameWarAudit: async () => axios.get(`${API_URL}/garrison_audit/getAllByNameWarAudit`).then(({ data }) => data?.data ?? []).catch((err) => { throw err }),
    getAllVehicles: async () => axios.get(`${API_URL}/garrison_inspection/vehicles/getAllVehicles`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })

};

export default GarrisonAuditService;